import '../../../css/web/UserModalRenew.css'
import useTheme from '../layoutscommon/DarkModeStorage'
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from "react-i18next";
import '../../../css/web/BtorageGlobalPasswordModal.css'
import commonClose from '../../../assets/img/commonClose.png'
import commonInput from '../../../assets/img/commonInput.png'


function BtorageGlobalPasswordModal({ focusData, easyPay, closeCardPasswordPopup }) {
    const { t } = useTranslation();
    const [theme] = useTheme();

    const [passwords, setPasswords] = useState(['', '', '', '', '', '']);
    const inputsRef = useRef([]);

    useEffect(() => {
        if (inputsRef.current[0]) {
            inputsRef.current[0].focus();
        }
    }, []);

    const handleChange = (e, index) => {
        setPasswordError(false);
        const text = e.target.value;
        if (text.length > 1) return;

        const newPasswords = [...passwords];
        newPasswords[index] = text;
        setPasswords(newPasswords);

        if (text && index < 5) {
            inputsRef.current[index + 1]?.focus();
        }

        if (newPasswords.every(p => p.length === 1)) {
            afterProcessPay(newPasswords.join(''));
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && passwords[index] === '') {
            if (index > 0) {
                const newPasswords = [...passwords];
                newPasswords[index - 1] = '';
                setPasswords(newPasswords);
                inputsRef.current[index - 1]?.focus();
            }
        }
    };

    const [passwordError, setPasswordError] = useState(false);
    const afterProcessPay = (enteredPassword) => {
        if (enteredPassword === focusData?.easyPassword) {
            easyPay();
            closeCardPasswordPopup();
        } else {
            setPasswordError(true);
        }
    };

    return (
        <div className="btorage-pay-pw-modal-container md-scope" data-theme={theme}>
            <div className="btorage-pay-pw-modal-header-container">
                <div className="btorage-pay-pw-modal-header-frame">
                    <div className="display-flex align-center m-l-10">
                        <img className="wd-20 ht-20" src={commonInput} alt="icon"/>
                    </div>
                    <div className="p-l-10">
                        <span className="font-s-12 fw-bold">{t('bpmTx4')}</span>
                    </div>
                    <button className="btorage-pay-pw-modal-close-bt" onClick={closeCardPasswordPopup}>
                        <img className="btorage-pay-pw-modal-close-img" src={commonClose} alt="close"/>
                    </button>
                </div>

                <div className="pd20">
                    <div className="display-flex just-cont-center gap4">
                        {passwords.map((val, i) => (
                            <div key={i} className="btorage-pay-pw-modal-password-container">
                                <input className="btorage-pay-pw-modal-password-input"
                                    ref={el => inputsRef.current[i] = el}
                                    type="password"
                                       autoComplete="new-password"
                                    inputMode="numeric"
                                    maxLength={1}
                                    value={val}
                                    onChange={(e) => handleChange(e, i)}
                                    onKeyDown={(e) => handleKeyDown(e, i)}/>
                            </div>
                        ))}
                    </div>

                    {passwordError && (
                        <div className="m-t-20">
              <span className="font-s-12 fw-bold" style={{color: '#EB939D'}}>
                {t('bpmTx5')}
              </span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default BtorageGlobalPasswordModal;